(() => {
  if (window.PoptexMaterialsMobile) { window.PoptexMaterialsMobile.init(); return; }
  const mobile = matchMedia('(max-width:1023px)');
  const init = () => {
  if (!mobile.matches) return;
  const page = document.querySelector('[data-materials-page]');
  if (!page || page.dataset.initialized === 'true') return;
  page.dataset.initialized = 'true';

  const menu = page.querySelector('[data-materials-menu]');
  const menuOpen = page.querySelector('[data-materials-menu-open]');
  const menuClose = page.querySelector('[data-materials-menu-close]');
  const menuScrim = page.querySelector('[data-materials-menu-scrim]');
  const search = page.querySelector('[data-materials-search]');
  const searchClear = page.querySelector('[data-materials-search-clear]');
  const newToggle = page.querySelector('[data-materials-new-only]');
  const grid = page.querySelector('[data-materials-grid]');
  const count = page.querySelector('[data-materials-count]');
  const empty = page.querySelector('[data-materials-empty]');
  const loading = page.querySelector('[data-materials-loading]');
  const cardTemplate = page.querySelector('[data-materials-card-template]');
  const filters = Array.from(page.querySelectorAll('[data-material-filter]'));
  const content = window.PoptexTemplateContent;
  const cardsById = new Map();
  let cards = [];
  const initialFilters = new URLSearchParams(window.location.search);
  let requestedMaterial = initialFilters.get('material');
  let activeMaterial = 'all';
  let newOnly = initialFilters.get('new') === '1';
  const selectedFamilies = new Set();
  const colorOptions = page.querySelector('[data-color-options]');
  const colorLabels = JSON.parse(page.querySelector('[data-color-labels]').textContent);
  let colorCatalog = null;
  let colorsLoading = false;
  let latestRecords = [];
  let ready = false;
  let failed = false;
  let renderVersion = 0;
  let disposed = false;

  const loadCardImage = (card) => {
    card.dataset.imageActivated = 'true';
    content?.setDisplayImage(card.querySelector('img'), card.querySelector('[data-image-placeholder]'), { previewImages: { display: card.dataset.imageUrl || '' } });
  };
  const imageObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      loadCardImage(entry.target);
      imageObserver.unobserve(entry.target);
    });
  }, { rootMargin: '300px' }) : null;

  const setMenu = (isOpen, restoreFocus = true) => {
    menu?.classList.toggle('is-open', isOpen);
    menuScrim?.classList.toggle('is-open', isOpen);
    menu?.setAttribute('aria-hidden', String(!isOpen));
    menuOpen?.setAttribute('aria-expanded', String(isOpen));
    document.body.classList.toggle('materials-menu-open', isOpen);
    if (menu) menu.inert = !isOpen;
    if (isOpen) menuClose?.focus();
    else if (restoreFocus) menuOpen?.focus({ preventScroll: true });
  };

  const resetMenu = () => setMenu(false, false);
  const resetOnDesktop = () => { if (!mobile.matches) resetMenu(); };
  mobile.addEventListener('change', resetOnDesktop);
  resetMenu();
  menuOpen?.addEventListener('click', () => setMenu(true));
  menuClose?.addEventListener('click', () => setMenu(false));
  menuScrim?.addEventListener('click', () => setMenu(false));
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', resetMenu));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu?.classList.contains('is-open')) setMenu(false);
  });
  window.addEventListener('pageshow', resetMenu);
  window.addEventListener('pagehide', () => document.body.classList.remove('materials-menu-open'));

  const normalizedSearch = () => (search?.value || '').trim().toLowerCase();

  const compareCards = (left, right) => Number(right.dataset.order) - Number(left.dataset.order);

  const render = () => {
    const query = normalizedSearch();
    newToggle?.setAttribute('aria-pressed', String(newOnly));
    cards.sort(compareCards).forEach((card, index) => {
      if (grid.children[index] !== card) grid.insertBefore(card, grid.children[index] || null);
    });
    let visibleCount = 0;
    cards.forEach((card) => {
      const searchable = `${card.dataset.name || ''} ${card.dataset.color || ''} ${card.dataset.keywords || ''}`.toLowerCase();
      const visible = (!newOnly || card.dataset.isNew === '1') && (activeMaterial === 'all' || card.dataset.materials.split(' ').includes(activeMaterial)) && (!selectedFamilies.size || (card.dataset.colorFamilies || '').split(' ').some((family) => selectedFamilies.has(family))) && (!query || searchable.includes(query));
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });
    if (count) count.textContent = String(visibleCount);
    if (empty) {
      empty.hidden = !ready || visibleCount !== 0;
      empty.querySelector('[data-materials-empty-title]').textContent = failed ? page.dataset.unavailableTitle : page.dataset.emptyTitle;
      empty.querySelector('[data-materials-empty-copy]').textContent = failed ? page.dataset.unavailableCopy : page.dataset.emptyCopy;
    }
    if (grid) grid.hidden = visibleCount === 0;
    if (searchClear) searchClear.hidden = query.length === 0;
  };

  const selectMaterial = (value) => {
    activeMaterial = value;
    filters.forEach((item) => {
      const selected = item.dataset.materialFilter === value;
      item.classList.toggle('is-active', selected);
      item.setAttribute('aria-pressed', String(selected));
    });
  };
  page.querySelector('.materials-tabs').addEventListener('click', (event) => {
    const filter = event.target.closest('[data-material-filter]');
    if (!filter) return;
    requestedMaterial = null;
    selectMaterial(filter.dataset.materialFilter);
    render();
  });
  const tabs = page.querySelector('.materials-tabs');
  const filterTemplate = page.querySelector('[data-materials-filter-template]');
  const seriesObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      loadSeriesImage(entry.target);
      seriesObserver.unobserve(entry.target);
    });
  }, { root: tabs, rootMargin: '0px 120px' }) : null;
  const loadSeriesImage = filter => {
    filter.dataset.imageActivated = 'true';
    const bounds = filter.getBoundingClientRect();
    const visible = bounds.left < window.innerWidth && bounds.right > 0 && bounds.top < window.innerHeight && bounds.bottom > 0;
    content.setImage(filter.querySelector('img'), filter.querySelector('[data-image-placeholder]'), filter.dataset.imageUrl, {priority:visible ? 'high' : 'auto'});
  };
  const syncFilters = (catalog, hasSnapshot) => {
    const groups = catalog.groups.filter(group => catalog.styles.some(style => style.groupId === group.id))
      .slice().sort((a,b) => (Number(b.sortOrder)||0) - (Number(a.sortOrder)||0) || String(a.code || a.id).localeCompare(String(b.code || b.id)));
    const ids = new Set(groups.map(group => group.id));
    for (let i=filters.length-1;i>=0;i--) {
      const filter=filters[i];
      if (filter.dataset.materialFilter !== 'all' && !ids.has(filter.dataset.materialFilter)) {
        seriesObserver?.unobserve(filter);filter.remove();filters.splice(i,1);
      }
    }
    page.querySelectorAll('[data-series-skeleton]').forEach(node => { node.hidden = ready; });
    let previous = filters.find(filter => filter.dataset.materialFilter === 'all');
    groups.forEach(group => {
      let filter = filters.find(item => item.dataset.materialFilter === group.id);
      if (!filter) {
        filter = filterTemplate.content.firstElementChild.cloneNode(true);
        filter.dataset.materialFilter = group.id;
        filters.push(filter);
      }
      const name = filter.querySelector('[data-series-name]');
      const displayName = group.shortName?.trim() || group.name;
      if (name.textContent !== displayName) name.textContent = displayName;
      filter.setAttribute('aria-label', group.name);
      if (previous.nextElementSibling !== filter) tabs.insertBefore(filter, previous.nextElementSibling);
      previous = filter;
      filter.dataset.imageUrl = group.materialUrl || '';
      const rect = filter.getBoundingClientRect();
      if (filter.dataset.imageActivated || !seriesObserver || (rect.left < window.innerWidth && rect.right > 0 && rect.top < window.innerHeight && rect.bottom > 0)) loadSeriesImage(filter);
      else seriesObserver.observe(filter);
    });
    if (requestedMaterial && hasSnapshot) {
      activeMaterial = ids.has(requestedMaterial) ? requestedMaterial : 'all';
      requestedMaterial = null;
    }
    if (activeMaterial !== 'all' && !ids.has(activeMaterial)) activeMaterial = 'all';
    selectMaterial(activeMaterial);
  };
  search?.addEventListener('input', render);
  newToggle?.addEventListener('click', () => {
    newOnly = !newOnly;
    render();
  });
  searchClear?.addEventListener('click', () => {
    if (search) search.value = '';
    search?.focus();
    render();
  });
  page.querySelector('[data-materials-reset]')?.addEventListener('click', () => {
    if (search) search.value = '';
    requestedMaterial = null;
    selectMaterial('all');
    newOnly = false;
    selectedFamilies.clear();
    updateColorButtons();
    render();
    search?.focus();
  });

  const updateColorButtons = () => {
    colorOptions.querySelectorAll('[data-color-family]').forEach((button) => {
      const code = button.dataset.colorFamily;
      button.setAttribute('aria-pressed', String(selectedFamilies.has(code)));
    });
  };
  colorOptions.addEventListener('click', (event) => {
    const button = event.target.closest('[data-color-family]');
    if (!button || !colorCatalog) return;
    const code = button.dataset.colorFamily;
    if (selectedFamilies.has(code)) selectedFamilies.delete(code);
    else selectedFamilies.add(code);
    updateColorButtons();
    render();
  });
  const syncCardColors = (card, record) => {
    const live = colorCatalog?.patternsById[record.id];
    const source = live || { colors: [] };
    const entries = Object.prototype.hasOwnProperty.call(source, 'colors')
      ? (Array.isArray(source.colors) ? source.colors : [])
      : [{ hex: source.colorHex, name: source.colorName, family: null }];
    const colors = entries.filter((color) => color && typeof color.hex === 'string' && /^#[0-9a-f]{6}$/i.test(color.hex.trim())).slice(0, 4);
    const validFamilies = new Set(colorCatalog?.families.map((family) => family.code) || []);
    card.dataset.colorFamilies = [...new Set(entries.map((color) => color?.family).filter((family) => validFamilies.has(family)))].join(' ');
    card.dataset.color = entries.map((color) => color?.name || '').join(' ');
    const container = card.querySelector('[data-materials-colors-list]');
    container.hidden = colors.length === 0;
    const signature = JSON.stringify(colors);
    if (container.dataset.colors === signature) return;
    container.dataset.colors = signature;
    container.replaceChildren(...colors.map((color) => {
      const swatch = document.createElement('span');
      swatch.className = 'materials-card__color';
      swatch.dataset.materialsColor = '';
      swatch.setAttribute('role', 'img');
      swatch.setAttribute('aria-label', color.name || color.hex);
      swatch.title = color.name || color.hex;
      swatch.style.setProperty('--material-color', color.hex.trim());
      return swatch;
    }));
  };
  let colorsReloadPending = false;
  const loadColors = async () => {
    if (colorsLoading) { colorsReloadPending = true; return; }
    colorsLoading = true;
    page.querySelector('[data-color-loading]').hidden = false;
    page.querySelector('[data-color-error]').hidden = true;
    try {
      const result = await window.PoptexApi.getDefaultClient().cms.getPatternColorCatalog();
      if (!page.isConnected) return;
      colorCatalog = result;
      const validCodes = new Set(result.families.map((family) => family.code));
      selectedFamilies.forEach((code) => { if (!validCodes.has(code)) selectedFamilies.delete(code); });
      colorOptions.querySelectorAll('[data-color-family]').forEach(button => { if (!validCodes.has(button.dataset.colorFamily)) button.remove(); });
      result.families.forEach((family) => {
        let button = [...colorOptions.querySelectorAll('[data-color-family]')].find((item) => item.dataset.colorFamily === family.code);
        if (!button) {
          button = document.createElement('button');
          button.type = 'button';
          button.className = 'materials-color-option';
          button.dataset.colorFamily = family.code;
          const check = document.createElement('span');
          check.className = 'materials-color-option__check';
          check.textContent = '✓';
          check.setAttribute('aria-hidden', 'true');
          button.append(check);
          colorOptions.append(button);
        }
        button.style.setProperty('--family-color', family.samples[0]);
        button.title = colorLabels[family.code] || family.name || family.code;
        button.setAttribute('aria-label', button.title);
      });
      colorOptions.hidden = false;
      updateColorButtons();
      latestRecords.forEach((record) => { const card = cardsById.get(record.id); if (card) syncCardColors(card, record); });
      render();
    } catch (_) {
      page.querySelector('[data-color-error]').hidden = false;
    } finally {
      colorsLoading = false;
      page.querySelector('[data-color-loading]').hidden = true;
      if (colorsReloadPending && page.isConnected) { colorsReloadPending = false; loadColors(); }
    }
  };
  page.querySelector('[data-color-retry]').addEventListener('click', loadColors);
  window.addEventListener('poptex:metadata-updated', () => {
    // Let CMS listeners invalidate their cached catalog before reading it again.
    queueMicrotask(() => { if (page.isConnected && colorCatalog) loadColors(); });
  });

  const syncCards = (snapshot, settled) => {
    ready = Boolean(snapshot) || settled;
    failed = !snapshot && settled;
    loading.hidden = ready;
    const catalog = window.PoptexProductContent.catalog(snapshot);
    syncFilters(catalog, Boolean(snapshot));
    const version = ++renderVersion;
    const records = content?.eventTemplates(snapshot, 'new') || [];
    latestRecords = records;
    const ids = new Set(records.map((record) => record.id));
    cardsById.forEach((card, id) => {
      if (!ids.has(id)) { imageObserver?.unobserve(card); card.remove(); cardsById.delete(id); }
    });
    // Input/color callbacks can render before the first batch. Do not let their
    // previous card list reinsert products removed by this metadata version.
    cards = [...cardsById.values()];
    const updateCard = (record, index) => {
      let card = cardsById.get(record.id);
      if (!card) {
        card = cardTemplate.content.firstElementChild.cloneNode(true);
        card.dataset.templateId = record.id;
        cardsById.set(record.id, card);
      }
      const related = window.PoptexProductContent.relatedStyles(record, catalog);
      const tiers = [...new Set(related.map((item) => String(item.tier || catalog.groupsById.get(item.groupId)?.tier || '').toLowerCase()))]
        .filter((tier) => ['premium', 'deluxe', 'luxury'].includes(tier));
      card.dataset.tiers = tiers.join(' ');
      card.dataset.materials = [...new Set(related.map((item) => item.groupId))].join(' ');
      card.dataset.name = record.name || '';
      card.dataset.color = record.colorName || '';
      card.dataset.keywords = [record.displayIntro, record.materialName, ...(record.keywords || []), ...related.map((item) => item.name)].filter(Boolean).join(' ');
      card.dataset.order = String(Number.isFinite(Number(record.sortOrder)) ? Number(record.sortOrder) : 0);
      card.dataset.isNew = record.isNew === true ? '1' : '0';
      card.dataset.createdAt = String(Date.parse(record.createdAt) || 0);
      card.querySelectorAll('[data-materials-link]').forEach((link) => {
        link.href = window.PoptexProductContent.templateUrl(page.dataset.rootUrl, record.id, snapshot);
        link.setAttribute('aria-label', `View ${record.name || 'product'}`);
      });
      card.querySelector('[data-materials-name]').textContent = record.name || '';
      card.querySelector('[data-materials-new]').hidden = record.isNew !== true;
      const tier = card.querySelector('[data-materials-tier]');
      tier.textContent = tiers.join(' / ');
      tier.hidden = !tiers.length;
      tier.className = `materials-card__tier${tiers.length === 1 ? ` materials-card__tier--${tiers[0]}` : ''}`;
      syncCardColors(card, record);
      const sizes = card.querySelector('[data-materials-sizes]');
      sizes.textContent = (Array.isArray(record.sizes) ? record.sizes : []).filter((size) => typeof size === 'string' && size.trim()).join(' / ');
      sizes.hidden = !sizes.textContent;
      const image = card.querySelector('img');
      image.alt = record.name || '';
      // Only folded display imagery is used in the catalog.
      const preview = content.displayPreview(record);
      card.dataset.imageUrl = preview?.url || '';
      if (card.dataset.imageActivated === 'true' || !imageObserver) loadCardImage(card);
      else imageObserver.observe(card);
    };
    let cursor = 0;
    const batch = () => {
      if (disposed || version !== renderVersion) return;
      const end = Math.min(cursor + 12, records.length);
      while (cursor < end) { updateCard(records[cursor], cursor); cursor++; }
      cards = [...cardsById.values()];
      render();
      if (cursor < records.length) requestAnimationFrame(batch);
    };
    requestAnimationFrame(batch);
  };

  const stopWatch = content ? content.watch(page, syncCards) : null;
  if (!content) syncCards(null, true);
  const unload = event => {
    if (!event.target.contains(page)) return;
    mobile.removeEventListener('change', resetOnDesktop);
    disposed = true; renderVersion++; stopWatch?.(); imageObserver?.disconnect(); seriesObserver?.disconnect();
    document.removeEventListener('shopify:section:unload', unload);
  };
  document.addEventListener('shopify:section:unload', unload);
  loadColors();
  };
  window.PoptexMaterialsMobile = { init };
  mobile.addEventListener('change', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();
